import {
    AllResultsSelectionItem,
    getItemWithTheSmallestValueOrManual,
    type SelectionDropdown,
    type SelectionDropdownItem,
    TopNDropdownItem,
    TopNRemainingSelectionItem,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";

type ValuesParams = {
    topNValues: readonly number[];
    fixedLimit?: number;
};

export function createExportSelectionDropdown({
    topNValues,
    fixedLimit = Number.POSITIVE_INFINITY,
}: ValuesParams): SelectionDropdown {
    return {
        getInitiallySelectedItem: getItemWithTheSmallestValueOrManual,
        getItems<Item extends SelectionDropdownItem>(
            numberOfResults: number,
            limit = Number.POSITIVE_INFINITY,
            mapLimitedListOfItems?: (listOfItems: readonly number[]) => readonly Item[],
        ): readonly Item[] | readonly SelectionDropdownItem[] {
            const lowestLimit = Math.min(limit, fixedLimit);
            const maximumPossibleValue = Math.min(numberOfResults, lowestLimit);

            if (maximumPossibleValue <= 0) {
                return [];
            }

            if (mapLimitedListOfItems) {
                return mapLimitedListOfItems(topNValues);
            }

            const possibleTopNValues = topNValues.filter((value) => value < maximumPossibleValue);
            const topNItems: readonly SelectionDropdownItem[] = possibleTopNValues.map((value) => {
                return new TopNDropdownItem({ value, id: `top-${value}` });
            });

            if (lowestLimit <= numberOfResults) {
                return topNItems.concat(
                    new TopNRemainingSelectionItem({
                        id: `top-${lowestLimit}`,
                        value: lowestLimit,
                    }),
                );
            }

            return topNItems.concat(new AllResultsSelectionItem(numberOfResults));
        },
    };
}
